/*eslint-disable */
const $ = window.jQuery = require('jquery');

import axios from 'axios';
import moment from 'moment';

export default {
  name: 'scheduled-interview-list',
  components: {
  },
  props: [],
  data () {
    return {
      interviewList:null,
      interviewListResults:[]
    }
  },
  computed: {
  },
  mounted () {
    this.getFiltersInterviewListMethod();
  },
  methods: {
    getFiltersInterviewListMethod(){
      this.$store.dispatch('getFilterInterviewListFun', {filter_key:'is_selected'}).then((res) => {
        this.interviewList = res.data.data
        this.interviewListResults = this.interviewList.results
      })

    },
    urlClipBoardMethod(value) {
      const copyUrl = this.domainLocationOrigin + '/interview/#' + value
      navigator.clipboard.writeText(copyUrl);
    },
    enabledJoinBtn(joinStartTime, joinEndTime) {
      var currentLocalDate = moment().format('MMMM Do YYYY');
      var currentLocalTime = moment().format('HH:mm:ss');
      var startDateCheck = moment(joinStartTime).format('MMMM Do YYYY')
      var startTimeCheck = moment(joinStartTime).format('HH:mm:ss')
      var endTimeCheck = moment(joinEndTime).format('HH:mm:ss')
      if(startDateCheck === currentLocalDate){
        if (currentLocalTime > startTimeCheck && endTimeCheck > currentLocalTime){
          return true;
        }else{   
          return false;
        }
      }else{
        return false;
      }
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.interviewListResults, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.interviewListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  },
  watch:{
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    $("body").removeClass("body_right_scroll_remove");
    next();
  },
}